// composables/useToast.js
export const useToast = () => {
  // Global state for all active toasts
  const toasts = useState("toasts", () => []);

  const addToast = (message, type = "alert-error", duration = 6000) => {
    const id = Date.now();

    // Add new toast to the array
    toasts.value.push({ id, message, type });

    // Remove it after the duration
    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id) => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  };

  return { toasts, addToast, removeToast };
};
